// @flow
import React from 'react';
import View from 'components/View';
import type { Style, Theme } from 'types';
import Text from 'components/Text';

type Props = {
  message: string,
  tipPosition: string,
  style?: Style
};

const styles = {
  relativeReference: {
    position: 'relative',
    height: '100%'
  },
  body: (props, { components: { ValidationMessage } }: Theme): Style => ({
    ...ValidationMessage.body,
    flexDirection: 'row',
    whiteSpace: 'nowrap',
    alignItems: 'center',
    height: '40px',
    position: 'absolute',
    right: '0px',
    top: '0px'
  }),
  tipLeft: (props, { components: { ValidationMessage } }: Theme): Style => ({
    display: 'flex',
    width: 0,
    height: 0,
    borderTop: '5px solid',
    borderRight: '10px solid',
    borderBottom: '5px solid',
    marginLeft: '-10px',
    marginTop: 'auto',
    marginBottom: 'auto',
    ...ValidationMessage.tipLeft
  }),
  tipRight: (props, { components: { ValidationMessage } }: Theme): Style => ({
    display: 'flex',
    width: 0,
    height: 0,
    borderTop: '5px solid',
    borderLeft: '10px solid',
    borderBottom: '5px solid',
    marginRight: '-10px',
    marginTop: 'auto',
    marginBottom: 'auto',
    ...ValidationMessage.tipRight
  }),
  content: (props, { components: { ValidationMessage } }): Style => ({
    ...ValidationMessage.content,
    display: 'flex',
    height: '100%',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '5px',
    padding: '15px'
  }),
  textStyle: (props, { components: { ValidationMessage } }): Style => ({
    ...ValidationMessage.text
  })
};

const ValidationMessage = ({ message, tipPosition, style }: Props) => (
  <View style={styles.relativeReference}>
    <View isVertical style={[styles.body, style]}>
      {(tipPosition === 'left' || tipPosition === 'leftright') && <View style={styles.tipLeft} />}
      <View style={styles.content}>
        <Text style={styles.textStyle}>{message}</Text>
      </View>
      {(tipPosition === 'right' || tipPosition === 'leftright') && <View style={styles.tipRight} />}
    </View>
  </View>
);

export default ValidationMessage;
